export default __webpack_public_path__ + "static/indahash-case-study-0e3a0d4dc48cfe2911a779b511be9a03.webp";